module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/5@2x_b9eb30b4bbf317138fba377bcbdb65c9.png";